enum ApplicationStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  DENIED = "DENIED",
  IN_REVIEW = "IN_REVIEW",
  CLOSED = "CLOSED",
}

export default ApplicationStatus;
